// extracted by mini-css-extract-plugin
module.exports = {"portfolio":"AssignUsers_portfolio__12DYE","controls":"AssignUsers_controls__1KdFj","divider":"AssignUsers_divider__3bDRc"};